import React, { useState, useEffect, useRef } from 'react';
import './Tutorials.scss';
import { Input } from 'antd';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import TutorialSkeleton from '../../../components/skeletons/TutorialSkeleton.jsx';
import { GetAllTutorialsApi } from '../../../api/request/tutorials.js';
import ReactPlayer from 'react-player'

export default function Tutorials() {
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [data, setData] = useState([]);
  const [tutorials, setTutorials] = useState({});
  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");
  const videoRef = useRef(null);

  const getAllTutorials = async () => {
    try {
      setIsLoading(true);
      let params = {
        SearchText: searchText,
        ApplyPagination: false,
        FilterText:"Active"
      }
      const { data } = await GetAllTutorialsApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(data?.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getAllTutorials();
  }, [searchText]);

  const addTutorialsModalHandler = (Item) => {
    setIsOpenModal(true);
    setTutorials(Item)
  }

  useEffect(() => {
    if (!isOpenModal && videoRef.current) {
      videoRef?.current?.pause();
    }
  }, [isOpenModal]);

  return (
    <div>
      <div className="flex justify-end flex-wrap gap-5">
        <div className="flex items-end">
          <div className="mr-3">
            <Input
              size="large"
              style={{ width: 220 }}
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onPressEnter={() => setSearchText(search)}
              prefix={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="w-5 h-5"
                >
                  <path
                    fill-rule="evenodd"
                    d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
                    clip-rule="evenodd"
                  />
                </svg>
              }
              suffix={
                search && (
                  <svg xmlns="http://www.w3.org/2000/svg" onClick={() => { setSearchText(""); setSearch(""); }}
                    viewBox="0 0 24 24" fill="#bebebe" className="size-5 cursor-pointer duration-300 hover:fill-[#969595]">
                    <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" />
                  </svg>
                )
              }
            />
          </div>
        </div>
      </div>

      <div>
        {isLoading ? (
          <TutorialSkeleton />
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 mt-6">
            {data?.map((item, index) => (
              <div key={index} className="shadow-lg cursor-pointer rounded-t-2xl overflow-hidden" onClick={() => addTutorialsModalHandler(item)}>
                <div className="relative pb-[56.25%] h-0">
                  <ReactPlayer
                    url={item.youtubeUrl || item.videoUrl}
                    className="absolute top-0 left-0 w-full h-full"
                    width="100%"
                    height="100%"
                    controls={false}
                  />
                </div>
                <div className="p-4">
                  <p className="text-lg font-semibold line-clamp-1">{item.title}</p>
                  <p className="text-[#7A7A7A] text-sm line-clamp-3 mt-2">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        )
        }

        <ModalComponent isOpen={isOpenModal} setIsOpen={setIsOpenModal} title='Tutorial' width={1000}>
          <div className="relative pb-[56.25%] h-0">
            {tutorials?.isYoutube ? (
              <ReactPlayer
                url={tutorials.youtubeUrl}
                className="absolute top-0 left-0 w-full h-full"
                width="100%"
                height="100%"
                controls
              />
            ) : (
              <video ref={videoRef} className='w-full' controls>
                <source src={tutorials?.videoUrl} type="video/mp4" />
                Your browser does not support video.
              </video>
            )}
          </div>
          <div className="p-4">
            <p className="text-lg font-semibold line-limit-1">{tutorials?.title}</p>
            <p className="text-[#7A7A7A] text-sm line-limit-2 mt-2">{tutorials?.description}</p>
          </div>
        </ModalComponent>
      </div>
    </div>
  )
}
